import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createStore, combineReducers, applyMiddleware } from "redux";
import infrastructureReducer, {
  languageReducer,
  cookiesReducer,
} from "./infrastructure/reducer";
import { loadLanguage } from "./Common/language";
import { reducer as oidcReducer } from "redux-oidc";
import { configLoaded } from "./infrastructure/actions";
import { httpMiddleware } from "./infrastructure/middleware";
import thunk from "redux-thunk";
import App from "./App";
import "./index.css";
import "./App.css";
import createUserManager from "./infrastructure/userManager";
import createOidcMiddleware, { OidcProvider } from "redux-oidc";
import { ApolloProvider } from "@apollo/react-hooks";
import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  HttpLink,
} from "apollo-boost";

const getJson = f => {
  return fetch(f).then(x => x.json());
};

const merge = (o, rest) => {
  var next = rest.pop();
  if (!next) return o;

  const merged = {
    ...o,
    ...next,
  };

  return merge(merged, rest);
};

const configUri = process.env.PUBLIC_URL + "/config.json";
const localUri = "/ee-static/members/local.json";
const files = [configUri, localUri].map(f => getJson(f));
Promise.all(files)
  .then(response => merge({}, response))
  .then(config => {
    const userManager = createUserManager(config);
    const oidcMiddleware = createOidcMiddleware(userManager);
    const reducers = {
      infrastructure: infrastructureReducer,
      language: languageReducer,
      oidc: oidcReducer,
      cookies: cookiesReducer(config),
    };
    const reducer = combineReducers(reducers);
    const middleware = applyMiddleware(
      thunk,
      oidcMiddleware,
      httpMiddleware(config)
    );
    const store = createStore(reducer, composeWithDevTools(middleware));
    //Add local stylesheet
    let localcss = window.document.createElement("link");
    localcss.href = `/ee-static/members/style.css`;
    localcss.rel = "stylesheet";
    window.document.getElementsByTagName("head")[0].appendChild(localcss);

    const graphql = config.apiUrl + "/graphql";
    const cache = new InMemoryCache();
    const httpLink = new HttpLink({ uri: graphql });

    const middlewareLink = new ApolloLink((operation, forward) => {
      operation.setContext({
        headers: {
          authorization: "Bearer " + store.getState().oidc.user.access_token,
        },
      });
      return forward(operation);
    });
    const link = middlewareLink.concat(httpLink);

    const client = new ApolloClient({
      link: link,
      cache: cache,
    });

    store.dispatch(configLoaded(config));
    loadLanguage("sv-SE", store.dispatch);

    ReactDOM.render(
      <Provider store={store}>
        <OidcProvider store={store} userManager={userManager}>
          <ApolloProvider client={client}>
            <App userManager={userManager} />
          </ApolloProvider>
        </OidcProvider>
      </Provider>,
      document.getElementById("root")
    );
  });
